import { useTranslation } from 'react-i18next'

export default function ManualPage() {
  const { t } = useTranslation()
  return <iframe title={t('shell.helpManual')} src="/user-manual.html" className="h-[calc(100vh-3.5rem)] w-full border-0" />
}
